import React from 'react';

interface MetricCardProps {
    title: string;
    value: string;
    description?: string;
}

const MetricCard: React.FC<MetricCardProps> = ({ title, value, description }) => (
    <div className="metric-card">
        <h3>{title}</h3>
        <p className="metric-value">{value}</p>
        {description ? <small>{description}</small> : null}
    </div>
);

export default MetricCard;
